import { createStore, compose, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import tron from '../config/Reactotron'
import createRootReducer from './ducks/index'
// eslint-disable-next-line import/no-cycle
import sagas from './sagas/index'

function getRouterBasename() {
  const configured = process.env.REACT_APP_SUBDIRECTORY
  if (configured && configured !== '/') {
    return configured.replace(/\/$/, '') || '/'
  }

  if (typeof window !== 'undefined') {
    const { pathname } = window.location
    const subpath = pathname.match(/^(\/oikos-client)(?=\/|$)/)
    if (subpath) return subpath[1]
  }

  const publicUrl = process.env.PUBLIC_URL || ''
  if (publicUrl.startsWith('http')) {
    try {
      const p = new URL(publicUrl).pathname.replace(/\/$/, '') || '/'
      if (p !== '/') return p
    } catch (e) { /* ignore */ }
  } else if (publicUrl && publicUrl !== '/') {
    return publicUrl.replace(/\/$/, '')
  }

  return '/'
}

export const history = createBrowserHistory({
  basename: getRouterBasename(),
})

const middlewares = [routerMiddleware(history)]
const sagaMonitor = process.env.REACT_APP_ENV === 'development' ? tron.createSagaMonitor() : null
const sagaMiddleware = createSagaMiddleware({ sagaMonitor })
middlewares.push(sagaMiddleware)

const composer = process.env.REACT_APP_ENV === 'development'
  ? compose(
    applyMiddleware(...middlewares),
    tron.createEnhancer(),
  )
  : compose(
    applyMiddleware(...middlewares),
  )

const store = createStore(createRootReducer(history), composer)

sagaMiddleware.run(sagas)

export default store
